import { HIRING_LAUNCH_FREE_MODE } from "../lib/hiringLaunchMode";

/**
 * @param {{
 *   open: boolean,
 *   billingSummary: object | null,
 *   onClose: () => void,
 * }} props
 */
export default function HiringBuyJobsModal({ open, billingSummary, onClose }) {
  if (!open) return null;

  const slots = Math.max(0, Math.floor(Number(billingSummary?.prepaidJobSlots) || 0));

  return (
    <div className="apply-help-overlay" role="presentation" onClick={onClose}>
      <div
        className="apply-help-modal nd1-hiring-buy-jobs-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="hiring-buy-jobs-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="apply-help-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <h2 id="hiring-buy-jobs-title" className="apply-help-title">
          {HIRING_LAUNCH_FREE_MODE ? "Your job slots" : "Buy a job slot"}
        </h2>
        <div className="apply-help-body">
          {HIRING_LAUNCH_FREE_MODE ? (
            <>
              <p>
                You have{" "}
                <strong>
                  {slots} job slot{slots === 1 ? "" : "s"}
                </strong>{" "}
                available. Use one each time you publish a role — they don&apos;t expire.
              </p>
              <p className="nd1-hiring-buy-jobs-modal__note">
                Need more? Drop us a line at{" "}
                <a href="mailto:hello@jobuwin.com">hello@jobuwin.com</a> and we&apos;ll help.
              </p>
            </>
          ) : (
            <>
              <p>
                Pay-as-you-go job slots don&apos;t expire — use them whenever you&apos;re ready to advertise a role.
              </p>
              <p className="nd1-hiring-buy-jobs-modal__note">
                Checkout isn&apos;t wired up yet — head to our pricing page to see plans and get in touch.
              </p>
            </>
          )}
        </div>
        <div className="nd1-hiring-buy-jobs-modal__actions">
          <button type="button" className="nd1-btn nd1-btn--accent" onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}

/**
 * @param {{ open: boolean, onClose: () => void }} props
 */
export function HiringManagePlanModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="apply-help-overlay" role="presentation" onClick={onClose}>
      <div
        className="apply-help-modal nd1-hiring-buy-jobs-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="hiring-manage-plan-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="apply-help-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <h2 id="hiring-manage-plan-title" className="apply-help-title">
          Change your plan
        </h2>
        <div className="apply-help-body">
          <p>
            {HIRING_LAUNCH_FREE_MODE
              ? "Subscriptions aren't part of launch mode right now. Need a hand? Email hello@jobuwin.com."
              : "Need a different monthly job allowance? Get in touch and we'll help you switch plans."}
          </p>
        </div>
        <div className="nd1-hiring-buy-jobs-modal__actions">
          <button type="button" className="nd1-btn nd1-btn--accent" onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
